export const spaceCadet = '#2E294E'
export const darkGray = '#282c35'
export const gray = '#aaa'
export const lightGray = '#ddd'
export const sepia = '#F7E9DC'
export const altSepia = 'rgba(230, 225, 219, 1)'
export const white = '#fff'
export const pinkRed = '#E25E79'
export const themeBlue = '#02A3DD'
